// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import axios from "axios";

const firebaseConfig = {
    apiKey: "AIzaSyB2nLVFWO3u6SaOd4BioHPdxvckUXdqd7Y",
    authDomain: "talabatek-4bea7.firebaseapp.com",
    projectId: "talabatek-4bea7",
    storageBucket: "talabatek-4bea7.firebasestorage.app",
    messagingSenderId: "119008136494",
    appId: "1:119008136494:web:ec83935ba695c71095bebf",
    measurementId: "G-7YZRYF3M21",
};

const firebaseApp = initializeApp(firebaseConfig);
const messaging = getMessaging(firebaseApp);

// Ask permission + get FCM token
export const requestForToken = async () => {
    try {
        // Wait for service worker to be ready before asking for token
        const registration = await navigator.serviceWorker.ready;

        // Reuse existing token if available
        const existingToken = localStorage.getItem("fcmToken");
        const authToken = localStorage.getItem("token");

        if (existingToken) {
            // ✅ Send existing token to server
            await axios.patch(
                `${process.env.REACT_APP_API_URL}/user/update`,
                { fcm: existingToken },
                {
                    headers: {
                        Authorization: `Bearer ${authToken}`,
                        "Content-Type": "application/json",
                    },
                },
            );
            return existingToken;
        }

        // ✅ Request new token (pass service worker explicitly)
        const token = await getToken(messaging, {
            vapidKey:
                "BHBfikqY8olpHPlcqj29svYWxyHIYXHPcWhkuI-cNorF47Go1wVR_CeKFjUoYaHJt4RkArolEbbaI4FaObLDh9c",
            serviceWorkerRegistration: registration, // 👈 critical line
        });

        if (token) {
            console.log("✅ FCM Token:", token);
            localStorage.setItem("fcmToken", token);

            await axios.patch(
                `${process.env.REACT_APP_API_URL}/user/update`,
                { fcm: token },
                {
                    headers: {
                        Authorization: `Bearer ${authToken}`,
                        "Content-Type": "application/json",
                    },
                },
            );
            return token;
        } else {
            console.warn("⚠️ No registration token available.");
        }
    } catch (error) {
        console.error("❌ Error getting token:", error);
    }
};
// Listen to foreground messages
export const listenToForegroundMessages = (callback) => {
    return onMessage(messaging, (payload) => {
        console.log("Foreground message received:", payload);
        callback(payload);
    });
};
const db = getFirestore(firebaseApp);

export { firebaseApp, messaging, db };
